import { z } from 'zod';
import { isoDateTimeSchema, uuidSchema } from './common';
import { roleSchema } from './role';

// Audit log — append-only, hash-chained per plan §6.5.
// Every administrative write produces a row. Hash chain verified weekly.

export const auditActionSchema = z.enum([
  // family / dancer
  'family.create',
  'family.update',
  'family.soft_delete',
  'dancer.create',
  'dancer.update',
  'dancer.soft_delete',
  // class / enrollment
  'class.create',
  'class.update',
  'class.cancel',
  'enrollment.create',
  'enrollment.update',
  'enrollment.drop',
  // attendance
  'attendance.mark',
  'attendance.edit',
  // production / lineup
  'production.create',
  'production.update',
  'lineup.reorder',
  'cast.assign',
  'cast.remove',
  // seat map / tickets
  'seat.block',
  'seat.unblock',
  'seat.refund',
  // billing
  'charge.create',
  'charge.adjust',
  'charge.refund',
  // payment
  'payment.succeed',
  'payment.fail',
  // auth / consent
  'admin.mfa_enroll',
  'admin.mfa_reset',
  'coppa.consent_grant',
  'coppa.consent_revoke',
  // misc
  'media.upload',
  'media.access',
]);
export type AuditAction = z.infer<typeof auditActionSchema>;

export const auditLogInputSchema = z.object({
  actor_user_id: uuidSchema.nullable(),
  actor_role: roleSchema.nullable(),
  action: auditActionSchema,
  resource_type: z.string().min(1).max(80),
  resource_id: uuidSchema.nullable(),
  before_state: z.unknown().nullable(),
  after_state: z.unknown().nullable(),
  metadata: z.record(z.unknown()).default({}),
});
export type AuditLogInput = z.infer<typeof auditLogInputSchema>;

export const auditLogSchema = auditLogInputSchema.extend({
  id: uuidSchema,
  occurred_at: isoDateTimeSchema,
  prev_hash: z.string().length(64).nullable(),
  row_hash: z.string().length(64),
});
export type AuditLogRow = z.infer<typeof auditLogSchema>;
